export const TOGGLE_FOOTER = 'TOGGLE_FOOTER';

export const toggleFooter = (val, msg, path) => ({
    type: TOGGLE_FOOTER,
    val,
    msg,
    path,
});
